import { useTranslation } from 'react-i18next';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FaTasks } from 'react-icons/fa';
import Button from 'react-bootstrap/Button';

function ViewButton({ handler, label }: { handler: () => void, label: string }): JSX.Element {
  const { t } = useTranslation();

  return (
    <OverlayTrigger
      trigger={['hover', 'focus']}
      placement="left"
      overlay={(
        <Tooltip id="{key}-tooltip">
          {t('View_Match_Results_Action_Description')}
        </Tooltip>
      )}
    >
      <Button variant="link" className="linkactions" onClick={handler}>
        <FaTasks />
        {label && (<span>{label}</span>)}
      </Button>
    </OverlayTrigger>
  );
}

export default ViewButton;
